import React, { ReactNode } from 'react';
import { FormItemProps, Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { JInputWrapper } from '../JInputWrapper';

const { TextArea } = Input;

export type JTextAreaProps = {
    /**
     * Action to update external module
     * @param value
     */
    onChange?: (e: string) => void;

    /**
     * label
     */
    label?: ReactNode;

    /**
     * name
     */
    name?: string | number | (string | number)[];

    /**
     * value
     */
    value?: string;

    /**
     * defaultValue
     */
    defaultValue?: string;

    /**
     * error message
     */
    errorMessage?: string;

    /**
     * placeholder
     */
    placeholder?: string;

    /**
     * showCount
     */
    showCount?: boolean;

    /**
     * maxLength
     */
    maxLength?: number;

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * ant design Form.Item props
     * https://ant.design/components/form/#API
     */
    itemProps?: FormItemProps;

    /**
     * ant design Input props
     * https://ant.design/components/input/#API
     */
    textAreaProps?: TextAreaProps;
};

export const JTextArea = ({
                              placeholder,
                              label,
                              name,
                              value,
                              defaultValue,
                              showCount = false,
                              maxLength = 100,
                              disabled = false,
                              onChange,
                              itemProps,
                              textAreaProps,
                              errorMessage
                          }: JTextAreaProps) => {
    return (<>
            {label ? <JInputWrapper label={label} name={name} {...itemProps}>
                    <TextArea
                        showCount={showCount}
                        maxLength={maxLength}
                        disabled={disabled}
                        defaultValue={value}
                        value={value}
                        placeholder={placeholder}
                        onChange={(e) => (onChange ? onChange(e?.target?.value) : '')}
                        aria-describedby={errorMessage}
                        {...textAreaProps}
                    />
                </JInputWrapper>
                : <TextArea
                    showCount={showCount}
                    maxLength={maxLength}
                    disabled={disabled}
                    defaultValue={defaultValue}
                    value={value}
                    placeholder={placeholder}
                    onChange={(e) => (onChange ? onChange(e?.target?.value) : '')}
                    aria-describedby={errorMessage}
                    {...textAreaProps}
                />}
        </>
    );
};
